import { historySessionsSelectors } from '../slices/history';
import type { RootState } from '../store';

// Adapter selectors (with O(1) lookups)
export const selectAllHistorySessions = historySessionsSelectors.selectAll;

// Loading and error states
export const selectIsHistoryLoading = (state: RootState) =>
  state.history.isLoading;

export const selectGeneratingTitleForSessionId = (state: RootState) =>
  state.history.generatingTitleForSessionId;
